import type { FunctionComponent } from 'react'

import styles from './bento-rectangle-three-parts.module.scss'
import Part from './part'
import { Container } from '@components/layout/grid'
import type { BentoPieceRectangleThreePartsFragment } from '@graphql/fragments/BentoPieceRectangleThreePartsFragment.graphql'

export const BentoRectangleThreeParts: FunctionComponent<Props> = ({
    parts,
}) => {
    return (
        <div className={styles.wrapper}>
            <Container className={styles.container}>
                {parts?.items.map((part) => (
                    <Part
                        key={part.sys.id}
                        heading={part.heading}
                        copy={part.copy}
                        image={part.image}
                    />
                ))}
            </Container>
        </div>
    )
}

export default BentoRectangleThreeParts

type Props = Omit<BentoPieceRectangleThreePartsFragment, 'sys' | 'type'> & {
    index?: number
}
